/* eslint-disable no-unused-vars */

import React from 'react';
import { Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { ColorsV2 } from 'app/constants/color';
import { checkForAssignedChartColor, formatNumber } from 'app/utils';
import { alpha } from '@mui/system';
import { AutoTextSize } from 'auto-text-size';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const DonutChart = ({ chartData = [], setClicked, clicked = [], totalNrOfObjects = 0 }) => {

  const chartColors = useSelector(state => state?.userSettings?.settings?.chartColors) || {};

  const getColor = id => {
    return chartColors[id] || checkForAssignedChartColor(id);
  };

  const { t } = useTranslation('translation', {keyPrefix: 'reusable_components'}); 

  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <foreignObject
        x={left + width / 2 - 50} // Explain these values - place the item in the middle of it's container?
        y={top + height / 2 - 15}
        width='100'
        height='30'
      >
          <Typography
          align='center'
          variant='h5'
          sx={{
            color: ColorsV2.white,
            // fontSize: `min(${width}px, 1.8rem)`,
            fontSize: 'auto'
          }}
          >
            <AutoTextSize mode='oneline'>
              {children}
            </AutoTextSize>
          </Typography>
      </foreignObject>
    );
  }

  const handleClick = (event, data) => {
    const dataIndex = data?.dataIndex;
    if (dataIndex || dataIndex === 0) {
      const dataLabels = chartData.map((item) => item.name);
      const clickedLabel = dataLabels?.[dataIndex];
      setClicked(prevClicked => {
        if (prevClicked.includes(clickedLabel)) {
          return prevClicked.filter(item => item !== clickedLabel);
        } else {
          return [...prevClicked, clickedLabel];
        }
      });
    }
  };

  return (
    <PieChart
      series={[
        {
          //   data: sampleData,
          data: chartData.map(item => ({
            label: item.name,
            value: item.spread,
            color: clicked?.length > 0 ? alpha(getColor(item.id), clicked.some((clickedItem) => clickedItem === item.name) ? 1 : 0.1) : getColor(item.id), // Adjust transparency if the category is selected
          })),
          valueFormatter: item => `${item.value.toFixed(0)}%`,
          innerRadius: 70, // Increase to 90 if you want nr of Objects to be displayed within
          outerRadius: 120,
          paddingAngle: 5,
          cornerRadius: 5,
          startAngle: -45,
          endAngle: 315,
          highlightScope: { fade: 'global', highlight: 'item' },
          highlighted: {additionalRadius: 10,},
          faded: { additionalRadius: -5, color: 'gray' },
        },
      ]}
      // onItemClick={(event, data) => handleClick(data)}
      onItemClick={(event, d) => handleClick(event, d)}
      slotProps={{
        legend: {
          direction: 'row',
          position: { vertical: 'top', horizontal: 'middle' },
          padding: 0,
          margin: 10,
          itemMarkWidth: 15,
          itemMarkHeight: 8,
          markGap: 5,
          itemGap: 10,
          labelStyle: {
            fill: ColorsV2.textInfo,
          },
        },
      }}
      height={400}
      width={350}
      margin={{ right: 0 }}
      // Add onclick event
    >
      {totalNrOfObjects &&
      <PieCenterLabel>{formatNumber(totalNrOfObjects)} {t('objects')}</PieCenterLabel>}
    </PieChart>
  );
};

export default DonutChart;
